var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jzbWrap" },
    [
      _vm.hasNotice
        ? _c("div", { staticClass: "notice-wrap" }, [
            _c("p", { staticClass: "notice-title" }, [
              _vm._v(_vm._s(_vm.notice.noticeType))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "notice-subtitle" }, [
              _vm._v(_vm._s(_vm.notice.noticeTitle))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "notice-content" }, [
              _vm._v(_vm._s(_vm.notice.noticeContent))
            ])
          ])
        : _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _vm.jzb_attribute === "private" ||
              _vm.jzb_attribute === "private-public"
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: "对私提现",
                        name: "person",
                        hasNotice: _vm.hasNotice
                      }
                    },
                    [
                      _vm.person
                        ? _c("userCash", { attrs: { type: 2 } })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.jzb_attribute === "public" ||
              _vm.jzb_attribute === "private-public"
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: "对公提现",
                        name: "business",
                        hasNotice: _vm.hasNotice
                      }
                    },
                    [
                      _vm.business
                        ? _c("userCash", { attrs: { type: 1 } })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17840ebc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17840ebc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/cashTab.vue
// module id = null
// module chunks = 